import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/rental-products',
    name: 'rentalProducts',
    component: () => import('@/views/restricted/rental-module/RentalModuleLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RENTAL_READ'],
      menuSelected: 'rental'
    }
  },
  {
    path: '/rental-products/repair-files/:repairFileBoomerangId',
    name: 'rentalProductList',
    component: () =>
      import('@/views/restricted/rental-module/acquisition/RentalProductListView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RENTAL_READ'],
      hideHeader: true,
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/rental-products/:rentalProductId(\\d+)/repair-files/:repairFileBoomerangId',
    name: 'rentalProductDetail',
    component: () =>
      import('@/views/restricted/rental-module/acquisition/RentalProductDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RENTAL_READ'],
      hideHeader: true,
      menuSelected: 'repairFiles'
    }
  }
]
